import React, { useState, useEffect } from "react";
import paginationFactory, {
  PaginationProvider,
} from "react-bootstrap-table2-paginator";

const PaginationTable = ({
  children,
  onPageChange,
  onPageSizeChange,
  onNeedMoreData,
  minPageSize = 25,
  maxPageSize = 100,
  totalRow = 0,
  increment = 50,
}) => {
  const sizePerPageOptionRenderer = ({ text, page, onSizePerPageChange }) => (
    <a
      key={text}
      tabIndex="-1"
      role="menuitem"
      data-page={page}
      onMouseDown={(e) => {
        e.preventDefault();
        onSizePerPageChange(page);
      }}
    >
      <li role="presentation" className="dropdown-item">
        {text}
      </li>
    </a>
  );
  const [currentPage, setCurrentPage] = useState(0);
  const [currentPageSize, setCurrentPageSize] = useState(minPageSize);
  
  // check if we need to load more data
  useEffect (() => {
    if (!onNeedMoreData) {
      return;
    }
    // on page change, check if we are close to the end of the list and should load some more data
    let totalLoaded = totalRow;
    let totalPages = totalLoaded / currentPageSize;
    let needMoreRecords = totalPages - currentPage < 3;

    // only load more data if we are toward the end of what we have loaded
    if (!needMoreRecords) {
      return;
    }
    
    onNeedMoreData();
  }, [currentPage, currentPageSize]);

  let pageSizeList = [
    {
      text: "" + minPageSize,
      value: minPageSize,
    },
  ];
  if (totalRow) {
    let i = totalRow;
    if (i > maxPageSize) {
      i = maxPageSize;
    }
    while (i >= increment) {
      let value = pageSizeList[pageSizeList.length - 1].value + increment;
      pageSizeList.push({ text: "" + value, value });
      i -= increment;
    }
  }
  const options = {
    showTotal: false,
    sizePerPage: currentPageSize,
    alwaysShowAllBtns: true,
    sizePerPageList: pageSizeList,
    onPageChange: (newPage) => {
      setCurrentPage(newPage);
      if (onPageChange) {
        onPageChange(newPage);
      }
    },
    onSizePerPageChange: (newPageSize) => {
      setCurrentPageSize(newPageSize);
      if (onPageSizeChange) {
        onPageSizeChange(newPageSize);
      }
    },
    sizePerPageOptionRenderer,
  };

  return (
    <PaginationProvider pagination={paginationFactory(options)}>
      {children}
    </PaginationProvider>
  );
};

export default PaginationTable;
